import { useMemo } from "react";
import { RootContext } from ".";
import { Theme } from "../../types/theme";
import { Range } from "../../types/range";
import { Controls } from "../../types/controls";

export interface RootProps {
  loop?: boolean;
  autoplay?: boolean;
  aspectRatio?: number | undefined;
  poster?: string | undefined;
  label?: string | undefined;
  theme?: Theme;
  clipRange?: Range;
  controls?: Controls;
  setClipRange?: (range: Range) => void;
  clippingEnabled?: boolean;
  setClippingEnabled?: (enable: boolean) => void;
  minimumClipGap?: number;
  children?: React.ReactNode;
}

const defaultTheme: Theme = {
  foreground: "#ffffff",
  fadedForeground: "#E8EEF2",
  emphasis: "#dd4533",
  fadedEmphasis: "#dd4533AA",
  primaryBackground: "#161616AA",
  seekBarBackground: "#636366",
  seekBarBuffer: "#8E8E93",
};

export const RootProvider = ({
  loop = false,
  autoplay = false,
  aspectRatio = 16 / 9,
  theme = defaultTheme,
  controls = Controls.fullControlBar,
  poster,
  label,
  clipRange,
  setClipRange,
  clippingEnabled = false,
  setClippingEnabled,
  minimumClipGap = 5,
  children,
}: RootProps) => {
  const value = useMemo(
    () => ({
      loop,
      autoplay,
      aspectRatio,
      poster,
      label,
      controls,
      theme,
      clipRange,
      setClipRange,
      clippingEnabled,
      setClippingEnabled,
      minimumClipGap,
    }),
    [
      aspectRatio,
      autoplay,
      clipRange,
      clippingEnabled,
      controls,
      label,
      loop,
      minimumClipGap,
      poster,
      setClipRange,
      setClippingEnabled,
      theme,
    ]
  );

  return <RootContext.Provider value={value}>{children}</RootContext.Provider>;
};
